import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { NewRollRow } from "../models/NewRolls";

export interface GetNewRollsParams {
	start: string;
	end: string;
	signal?: AbortSignal;
}

export const getNewRollsData = async ({
	start,
	end,
	signal,
}: GetNewRollsParams): Promise<NewRollRow[]> => {
	const apiService = new MESApiService();
	// The procedure takes only @start/@end/@isExporting: the grid sorts and
	// pages client-side and renders raw UTC datetimes. The pagination and
	// timeZone parameters existed for the legacy procedure.
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
		// BIT param: the API rejects numbers, it must be a JS boolean. The grid
		// does its own Excel export, so the exporting branch is never needed.
		{ name: "isExporting", value: false },
	];
	const resp = await apiService.callV2(
		"[ROLLS].[GetNewRollsDataWeb]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching new rolls");
	}
	return get(resp, "data.tables[0].rows", []) as NewRollRow[];
};
